import axios from 'axios'

import { baseURL } from '../config/index.js'
import VueCookies from "vue-cookies";
import store from '../store/index'
import router from "@/router";

// axios.defaults.baseURL = "http://192.168.0.166:5000/"
// axios.defaults.baseURL = baseURL
// axios.defaults.baseURL = 'http://research.szltech.com:4001'
if(process.env.NODE_ENV === "development"||store.state.debugMode){
    // axios.defaults.baseURL = 'http://192.168.0.32:4001'
    // axios.defaults.baseURL = 'http://183.6.107.160:23800'
    // axios.defaults.baseURL = 'http://research.szltech.com:4001'
    // axios.defaults.baseURL = 'http://192.168.0.32:4001'
    // 本地调试与正式环境保持一致，直接请求线上后端；本地起后端服务时改回下行
    // axios.defaults.baseURL = 'http://research.szltech.com:4001'
    axios.defaults.baseURL = 'http://127.0.0.1:4041'
    // axios.defaults.baseURL = 'http://192.168.0.194:4001/'

    // 后端机器
    // axios.defaults.baseURL = ' http://192.168.0.98:4001/'

}else{
    axios.defaults.baseURL = 'http://research.szltech.com:4001'
}
// axios.defaults.baseURL = "http://127.0.0.1:4021"
// axios.defaults.baseURL = "http://139.196.75.8:4001"
//响应超时的时间
axios.defaults.timeout = 50000;

//接口请求拦截
axios.interceptors.request.use(
    config => {
        config.headers = {Authorization: 'Bearer ' + VueCookies.get("token") } //设置响应头部
        return config
    }
)

// get
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res)
        }).catch(err => {
            // console.log('get err',err.data)
            reject(err)
        })
    })
}

// post
export function post(url, params,options) {
    // console.log('url',url)
    return new Promise((resolve, reject) => {
        axios.post(url, Object.assign(params,{userid:VueCookies.get("userid"),username:VueCookies.get("username")}),options)
            .then(res => {
                // console.log('post success',res.data)
                if(res.data.code==60001){
                    // console.log('重定向登录')
                    router.replace({
                        path:'/login'
                    })
                    reject('login')
                    return
                }
                resolve(res.data)
            })
            .catch(err => {
                // console.log('post err',err.data)
                reject(err.data)
            })
    })
}

export function post2(url, params,options) {
    return new Promise((resolve, reject) => {
        axios.post(url, Object.assign(params,{userid:VueCookies.get("userid"),username:VueCookies.get("username")}),options)
            .then(res => {
                // console.log('post success',res.data)
                if(res.data.code==60001){
                    // console.log('重定向登录')
                    router.replace({
                        path:'/login'
                    })
                    reject('login')
                    return
                }
                resolve(res)
            })
            .catch(err => {
                // console.log('post err',err.data)
                reject(err.data)
            })
    })
}

export default axios




